<template>
  <ingresante-a-b-m-docente :headers="headers"> </ingresante-a-b-m-docente>
</template>

<script>
import { mapState } from "vuex";
import IngresanteABMDocente from "@/views/ingresante/IngresanteABMDocente";

export default {
  name: "ingresantesDocentes",
  components: { IngresanteABMDocente },
  data() {
    return {
      headers: [
        // {text:'Id',value:'id'},
        { text: "Nombre", value: "nombre" },
        { text: "Apellido", value: "apellido" },
        { text: "email", value: "email" },
        { text: "Dni", value: "dni" },
        { text: "Telefono", value: "telefono" },
        // { text: "Carrera", value: "carrera.codigo" },
        // { text: "Matriculado", value: "matriculado" },
        { text: "Acciones", value: "actions" },
      ],
    };
  },
  computed: {
    ...mapState("IngresanteModule", ["fields"]),
    // headers(){
    //   var items = [];
    //   for (var i in this.fields){
    //     items.push({
    //       value:i,text:this.fields[i]
    //     })
    //   }
    //   items.push( {text:'Acciones',value:'actions'});
    //   return items;
    // }
  },
};
</script>

<style scoped></style>
